import "core-js/modules/es6.function.name";
import _defineProperty from "/vercel/16327899/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import { css } from "@chakra-ui/css";
import { pseudoSelectors } from "@chakra-ui/parser";
import { get, isNumber, isString, runIfFn, __DEV__ } from "@chakra-ui/utils";
import * as React from "react";
import { getComponentStyles } from "./component";
/**
 * Carefully selected html elements for chakra components.
 * This is mostly for `chakra.<element>` syntax.
 */

export var domElements = ["a", "abbr", "address", "area", "article", "aside", "b", "bdi", "bdo", "big", "blockquote", "button", "caption", "cite", "circle", "code", "col", "dd", "del", "details", "dfn", "div", "dl", "dt", "em", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "header", "hr", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "mark", "nav", "ol", "optgroup", "option", "output", "p", "path", "picture", "pre", "q", "rect", "s", "svg", "section", "select", "small", "span", "strong", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "tr", "u", "ul", "video"];
export function pseudoProps(_ref) {
  var theme = _ref.theme,
      props = _objectWithoutPropertiesLoose(_ref, ["theme"]);

  var result = {};

  for (var prop in props) {
    if (prop in pseudoSelectors) {
      var style = css(_defineProperty({}, prop, props[prop]))(theme);
      result = _extends({}, result, style);
    }
  }

  return result;
}
export function truncateProp(_ref2) {
  var isTruncated = _ref2.isTruncated,
      noOfLines = _ref2.noOfLines;

  if (isNumber(noOfLines)) {
    return {
      overflow: "hidden",
      textOverflow: "ellipsis",
      display: "-webkit-box",
      WebkitBoxOrient: "vertical",
      WebkitLineClamp: noOfLines
    };
  }

  if (isTruncated) {
    return {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap"
    };
  }
}
export function layerStyleProp(_ref3) {
  var layerStyle = _ref3.layerStyle,
      textStyle = _ref3.textStyle,
      theme = _ref3.theme;

  if (layerStyle) {
    return get(theme, "layerStyles." + layerStyle);
  }

  if (textStyle) {
    return get(theme, "textStyles." + textStyle);
  }
}
export function applyProp(tag) {
  return function (props) {
    var _theme$config;

    var theme = props.theme,
        applyProp = props.apply;
    var shouldAutoApply = theme == null ? void 0 : (_theme$config = theme.config) == null ? void 0 : _theme$config.shouldMapElementToStyles;
    var defaultApply = !!shouldAutoApply ? "styles." + tag : undefined;
    var apply = applyProp != null ? applyProp : defaultApply;
    if (!apply) return undefined;
    /**
     * css function knows how to resolve the `apply` prop
     * so need to use `get(...)` function.
     */

    return css({
      apply: apply
    })(theme);
  };
}
export default function isTag(target) {
  return isString(target) && (__DEV__ ? target.charAt(0) === target.charAt(0).toLowerCase() : true);
}
/**
 * Get the display name of a component.
 * It's really useful when debugging in Dev Tools.
 *
 * @param primitive the react element or component type
 */

export function getDisplayName(primitive) {
  return isTag(primitive) ? "chakra." + primitive : getComponentName(primitive);
}

function getComponentName(primitive) {
  return (__DEV__ ? isString(primitive) && primitive : false) || !isString(primitive) && primitive.displayName || !isString(primitive) && primitive.name || "ChakraComponent";
}

export function forwardRef(comp) {
  return /*#__PURE__*/React.forwardRef(comp);
}
export function componentProps(options) {
  return function (propsWithTheme) {
    var computedStyles = {};
    var theme = propsWithTheme.theme;
    /**
     * Users can pass a base style to the component options.
     *
     * @example
     * const Button = chakra("button", {
     *  baseStyle: {
     *    margin: 4,
     *    color: "red.300"
     *  }
     * })
     */

    if (options == null ? void 0 : options.baseStyle) {
      var baseStyleObject = runIfFn(options.baseStyle, propsWithTheme);
      var baseStyle = css(baseStyleObject)(theme);
      computedStyles = _extends({}, computedStyles, baseStyle);
    }
    /**
     * Users can pass a theme key to reference styles in the theme
     * Styles will be read from `theme.components.<themeKey>`
     *
     * @example
     * const Button = chakra("button", {
     *  themeKey: "Button"
     * })
     */


    if (options) {
      var styles = getComponentStyles(propsWithTheme, options);
      computedStyles = _extends({}, computedStyles, styles);
    }

    return computedStyles;
  };
}